<script>
  import Checkbox from '../Checkbox/Checkbox.vue';

  export default {
    name: 'll-list-item',

    components: {
      'll-checkbox': Checkbox,
    },

    props: {
      /**
       * The item to be selected
       */
      item: {
        type: Object,
        default: () => ({}),
      },

      /**
       * Whether this row can be selected.
       */
      isSelectable: {
        type: Boolean,
        default: false,
      },

      /**
       * Whether this row's checkbox should be indeterminite
       */
      isIndeterminate: {
        type: Boolean,
        default: false,
      },

      /**
       * Whether this row has an actions column or not. By default list items will
       * be styled to include actions. Use `not-actionable` to restyle a row that
       * has no actions.
       */
      notActionable: {
        type: Boolean,
        default: false,
      },

      /**
       * Whether this row is selected.
       */
      selected: {
        type: Boolean,
        default: false,
      },

      /**
       * Disables the checkbox
       */
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    emits: ['select'],

    methods: {
      /**
       * @param {boolean} value emit change event when item is selected
       */
      onSelect(value) {
        this.$emit('select', { item: this.item, value });
      },
    },
  };
</script>

<template>
  <li
    class="shadow-low"
    :class="[$style.item, { [$style['is-selectable']]: isSelectable, [$style['not-actionable']]: notActionable }]"
  >
    <ll-checkbox
      v-if="isSelectable"
      data-test="checkbox|select-item"
      :checked="selected"
      :class="$style.checkbox"
      :disabled="disabled || null"
      :indeterminate="isIndeterminate"
      @update:checked="onSelect"
    />
    <slot></slot>
  </li>
</template>

<style module>
  @reference "../../../styles/main.css";

  @layer utilities {
    .item {
      background: var(--color-white);
      border-radius: var(--radius-sm);
      column-gap: var(--grid-gutter);
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      margin-bottom: --spacing(6);
      padding: --spacing(3);
      padding-top: --spacing(12);
      position: relative;
      row-gap: var(--grid-gutter);
    }

    @media (width >= theme(--breakpoint-md)) {
      .item {
        grid-template-columns: repeat(8, 1fr);
      }
    }

    @media (width >= theme(--breakpoint-lg)) {
      .item {
        align-items: center;
        border-bottom: 1px solid var(--color-ice-200);
        border-radius: 0;
        box-shadow: none;
        grid-template-columns: repeat(12, 1fr);
        margin-bottom: 0;
        padding: --spacing(6);
        row-gap: 0;
      }

      .item:last-child {
        border: 0;
        border-bottom-left-radius: var(--radius-sm);
        border-bottom-right-radius: var(--radius-sm);
      }
    }

    @media (width >= theme(--breakpoint-lg)) {
      .is-selectable {
        grid-template-columns: --spacing(1.5) repeat(12, 1fr);
      }
    }

    .not-actionable {
      padding-top: --spacing(3);
    }

    @media (width >= theme(--breakpoint-lg)) {
      .not-actionable {
        padding-top: --spacing(6);
      }
    }

    .checkbox {
      left: --spacing(3);
      position: absolute !important;
      top: 0;
    }

    @media (width >= theme(--breakpoint-lg)) {
      .checkbox {
        left: 0;
        position: relative !important;
      }

      .checkbox label {
        padding: 10px;
      }
    }
  }
</style>
